import type { ComponentNode } from '../../../store/checkoutBuilder/types';
import TextAdapter from './TextAdapter';
import ImageAdapter from './ImageAdapter';
import TimerAdapter from '../adapters/TimerAdapter';
import ReviewAdapter from '../adapters/ReviewAdapter';
import ListAdapter from '../adapters/ListAdapter';
import AdvantagesAdapter from '../adapters/AdvantagesAdapter';

export type RenderOptions = {
  selected: boolean;
  onSelect: () => void;
  onUpdateProps: (patch: Record<string, any>) => void;
  dragHandleProps?: any;
  onDelete?: () => void;
  onDuplicate?: () => void;
};

export function renderComponent(node: ComponentNode, opts: RenderOptions) {
  switch (node.compType) {
    case 'texto':
      return <TextAdapter node={node} {...opts} />;
    case 'imagem':
      return (
        <ImageAdapter
          node={node}
          selected={opts.selected}
          onSelect={opts.onSelect}
          onUpdateProps={opts.onUpdateProps}
          dragHandleProps={opts.dragHandleProps}
          onDelete={opts.onDelete}
          onDuplicate={opts.onDuplicate}
        />
      );
    case 'cronometro':
      return (
        <TimerAdapter
          componentId={node.id}
          selected={opts.selected}
          dragHandleProps={opts.dragHandleProps}
        />
      );
    case 'avaliacao':
      return (
        <ReviewAdapter
          componentId={node.id}
          selected={opts.selected}
          dragHandleProps={opts.dragHandleProps}
        />
      );
    case 'lista':
      return (
        <ListAdapter
          componentId={node.id}
          selected={opts.selected}
          dragHandleProps={opts.dragHandleProps}
        />
      );
    case 'vantagens':
      return (
        <AdvantagesAdapter
          componentId={node.id}
          selected={opts.selected}
          dragHandleProps={opts.dragHandleProps}
        />
      );
    default:
      return <div className="text-xs text-gray-400">Tipo não suportado: {node.compType}</div>;
  }
}
